import React from 'react';
import Image from 'next/image';

import useMediaQuery from 'utils/useMediaQuery';
import { ReloanCalculator } from 'components/ReloanCalculator';
import { ReloanApplication } from 'components/ReloanApplication';
import { Modal } from 'components/Modal';

import styles from './ReloanHero.module.scss';

interface Props {
  type?: string;
}

export const ReloanHero: React.FC<Props> = ({ type }) => {
  const [isMobile, setIsMobile] = React.useState(Boolean);
  const max768px = useMediaQuery('(max-width: 768px)');

  React.useEffect(() => {
    setIsMobile(max768px);
  }, [max768px]);

  const mobileSrc = '/assets/images/reloan-hero-mobile-3-min.jpg';
  const desktopSrc = '/assets/images/reloan-hero-desktop-3-min.jpg';
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <Image
          layout="fill"
          objectFit="cover"
          src={isMobile ? mobileSrc : desktopSrc}
          alt="Två personer sitter avslappnat på taket av en bil och njuter av utsikten"
          quality={isMobile ? 100 : 100}
        />
        <div className={styles.texts}>
          <h1>
            <span>Sänk månads-kostnaden</span> på ditt billån
          </h1>
          <p>
            Med Blipp kan du enkelt flytta ditt nuvarande billån. Vi erbjuder en unik tjänst som
            hjälper dig att spara pengar och få bättre villkor.
          </p>
          <ul>
            <li>Lägre månadskostnad och bättre villkor</li>
            <li>Spara pengar och få bättre villkor</li>
            <li>Möjlighet att lägga om försäkringen till 20% rabatt</li>
          </ul>
          {type === 'application' ? (
            <div className={styles.howItWorksButton}>
              <Modal ButtonContent={<span className={styles.button}>Så fungerar Re:Loan</span>}>
                <h4>Så fungerar Re:loan</h4>
                <p>
                  Vi gör det enkelt att lägga om ditt billån! Här är hur det går till – steg för
                  steg:
                </p>
                <h3>1. Lösen av lån</h3>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                  Ipsum has been the industry standard dummy text.
                </p>
                <h3>2. Ägarbyte</h3>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                  Ipsum has been the industry standard dummy text.
                </p>
                <h3>3. Nya månadskostnad</h3>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                  Ipsum has been the industry standard dummy text.
                </p>
              </Modal>
            </div>
          ) : null}
          <div className={styles.trustpilot}>
            <span>Utmärkt</span>
            <Image
              width={120}
              height={24}
              src="/assets/icons/logo/Trustpilot_rating.svg"
              alt="Trustpilot betyg"
            />
            <a href="https://se.trustpilot.com/review/blipp.se" target="_blank" rel="noreferrer">
              <Image
                width={100}
                height={24}
                src="/assets/icons/logo/Trustpilot_brandmark.svg"
                alt="Trustpilot logotyp"
              />
            </a>
          </div>
        </div>
        <div className={`${styles.texts} ${styles.calculatorWrapper}`}>
          {type === 'application' ? <ReloanApplication /> : <ReloanCalculator />}
        </div>
      </div>
    </div>
  );
};
